module.exports = __webpack_public_path__ + "static/media/id.0bd74b0b.svg";